import { Divider } from 'antd'
import CantileverRow from 'components/CantileverRow'
import React from 'react'
import styled from 'styled-components'

const LeadingContentContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const StyledDivider = styled(Divider)`
  height: 1.075rem;
  margin-top: 0.1875rem;
`

const StyledTitle = styled.span`
  cursor: default;
`

export const PageHeader: React.FC<{
  title: string
  subtitle?: string
  icon?: React.ReactNode
  trailingContent?: React.ReactNode
}> = ({ title, subtitle, icon, trailingContent }) => (
  <CantileverRow
    pageTitle
    leadingContent={
      <LeadingContentContainer>
        {icon && <span>{icon}</span>}
        <StyledTitle>{title}</StyledTitle>
        {subtitle && (
          <>
            <StyledDivider type='vertical' />
            <StyledTitle>{subtitle}</StyledTitle>
          </>
        )}
      </LeadingContentContainer>
    }
    trailingContent={trailingContent}
  />
)
